import { AdActions, PlayerEvents, type IEventDispatcher } from '@4tn/core-audio-player-shared';

import { streamStartTealiumEventHandler } from './event-handlers/streamStartTealiumEventHandler';
import { streamResumedTealiumEventHandler } from './event-handlers/streamResumedTealiumEventHandler';
import { streamStopTealiumEventHandler } from './event-handlers/streamStopTealiumEventHandler';
import { streamPauseTealiumEventHandler } from './event-handlers/streamPauseTealiumEventHandler';
import { streamSwitchTealiumEventHandler } from './event-handlers/streamSwitchTealiumEventHandler';
import { streamHeartBeatTealiumEventHandler } from './event-handlers/streamHeartBeatTealiumEventHandler';
import { playerReconnectTealiumEventHandler } from './event-handlers/playerReconnectTealiumEventHandler';
import { streamEndedTealiumEventHandler } from './event-handlers/streamEndedTealiumEventHandler';
import { streamErrorTealiumEventHandler } from './event-handlers/streamErrorTealiumEventHandler';
import { streamMutedTealiumEventHandler } from './event-handlers/streamMutedTealiumEventHandler';
import { streamUnmutedTealiumEventHandler } from './event-handlers/streamUnmutedTealiumEventHandler';
import { streamMuteStopTealiumEventHandler } from './event-handlers/streamMuteStopTealiumEventHandler';
import { streamUnmuteStartTealiumEventHandler } from './event-handlers/streamUnmuteStartTealiumEventHandler';

export const configureUTag = (eventDispatcher: IEventDispatcher) => {
  eventDispatcher.on(AdActions.AD_START, () => {});
  eventDispatcher.on(AdActions.AD_BLOCKER_DETECTED, () => {});
  eventDispatcher.on(AdActions.AD_STOP, () => {});

  eventDispatcher.on(PlayerEvents.STREAM_START, streamStartTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_RESUMED, streamResumedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_STOP, streamStopTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_SWITCH, streamSwitchTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_PAUSE, streamPauseTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_ENDED, streamEndedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_MUTED, streamMutedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_UNMUTED, streamUnmutedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_MUTE_STOP, streamMuteStopTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_UNMUTE_START, streamUnmuteStartTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_ERROR, streamErrorTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_STATUS, () => {});
  eventDispatcher.on(PlayerEvents.STREAM_FAIL, () => {});
  eventDispatcher.on(PlayerEvents.HEARTBEAT, streamHeartBeatTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.TRACK_CUE_POINT, () => {});
  eventDispatcher.on(PlayerEvents.PLAYER_RECONNECT, playerReconnectTealiumEventHandler);

  return () => {
    eventDispatcher.removeListener(AdActions.AD_START, () => {});
    eventDispatcher.removeListener(AdActions.AD_BLOCKER_DETECTED, () => {});
    eventDispatcher.removeListener(AdActions.AD_STOP, () => {});

    eventDispatcher.removeListener(PlayerEvents.STREAM_START, streamStartTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_RESUMED, streamResumedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_STOP, streamStopTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_SWITCH, streamSwitchTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_PAUSE, streamPauseTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_ENDED, streamEndedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_MUTED, streamMutedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_UNMUTED, streamUnmutedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_MUTE_STOP, streamMuteStopTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_UNMUTE_START, streamUnmuteStartTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_ERROR, streamErrorTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_STATUS, () => {});
    eventDispatcher.removeListener(PlayerEvents.STREAM_FAIL, () => {});
    eventDispatcher.removeListener(PlayerEvents.HEARTBEAT, streamHeartBeatTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.TRACK_CUE_POINT, () => {});
    eventDispatcher.removeListener(PlayerEvents.PLAYER_RECONNECT, playerReconnectTealiumEventHandler);
  };
};
